import clsx from 'clsx'
import React, {useMemo} from 'react'

import {PAYMENT_SYSTEMS} from '../../consts'
import {desktopClasses, desktopSystemClasses, mobileClasses, mobileSystemClasses} from './PaymentSystemIcon.classes'
import {PaymentSystemIconProps} from './PaymentSystemIcon.types'

const getClasses = (isMobile = false) =>
  isMobile
    ? {classes: mobileClasses, systemClasses: mobileSystemClasses}
    : {classes: desktopClasses, systemClasses: desktopSystemClasses}

const PaymentSystemIcon: React.FC<PaymentSystemIconProps> = ({className, paymentSystem, mobile}) => {
  const {classes, systemClasses} = getClasses(mobile)

  const validPaymentSystem = useMemo(() => {
    const value = paymentSystem?.toLowerCase()

    return PAYMENT_SYSTEMS.find(system => system === value)
  }, [paymentSystem])

  const logoClasses = clsx(classes.logo, validPaymentSystem && systemClasses[validPaymentSystem], className)

  return <div className={logoClasses} />
}

PaymentSystemIcon.displayName = 'PaymentSystemIcon'

export default React.memo(PaymentSystemIcon)
